xplenty.directive('formLocator', function () {
  return {
    link(scope) {
      scope.$emit('formLocator');
    },
  };
});
